import { Component, OnInit, Input } from '@angular/core';
import { TableService } from "../../../services/table.service";
import { ConfirmModalComponent } from "../../confirm-modal/confirm-modal.component";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-table-delete-activate',
  templateUrl: './table-delete-activate.component.html',
  styleUrls: ['./table-delete-activate.component.scss']
})
export class TableDeleteActivateComponent implements OnInit {
  @Input() tableId: number = -1;
  @Input() isActivate: boolean = true;

  public errorDeleteStatus: string = '';
  public errorChangeActivateStatus: string = '';

  constructor(
    private tableService: TableService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.isActivate = this.parseBoolean(this.isActivate);
  }

  parseBoolean(str): boolean {
    return (str == 'False' ? false : true);
  }

  changeActivate() {
    this.tableService.changeActivate(this.tableId).subscribe((res) => {
      if (res['message'] == 'ok') {
        this.isActivate = !this.isActivate;
      }
      else if (res['message'] == 'error' && res['detail'] == 'has duel with not finished status') {
        this.errorChangeActivateStatus = 'Нельзя деактивировать стол с незавершёнными встречами';
      }
    });
  }

  delete() {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
        size: 'md',
        windowClass: 'testModalStyle',
        centered: true,
      });
      modalRef.componentInstance.message = 'Удалить стол из всех турниров?';
      modalRef.result.then((result) => {
        if (result) {
          this.tableService.delete(this.tableId).subscribe((res) => {
            if (res['message'] == 'ok' || (res['message'] == 'error' && res['detail'] == 'table does not exist')) {
              this.errorDeleteStatus = '';
              window.location.reload();
            }
            else if (res['message'] == 'error' && res['detail'] == 'has duel with not finished status') {
              this.errorDeleteStatus = 'Нельзя удалить стол с незавершёнными встречами';
            }
          });
        }
      });
  }

}
